import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { CreateAbsenceRequestDialogProvider } from '@/features/absences/context/create-absence-request-dialog-context';
import { ThemeProvider } from '../components/theme-provider';
import { ErrorBoundary } from '../components/ui/error-boundary';

interface RouterContext {
  queryClient: QueryClient;
}

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <h1 className="text-2xl font-semibold text-foreground">404 - Page Not Found</h1>
      <p className="text-muted-foreground">The page you're looking for doesn't exist.</p>
    </div>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  return (
    <ThemeProvider defaultTheme="system">
      <CreateAbsenceRequestDialogProvider>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
        {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
      </CreateAbsenceRequestDialogProvider>
    </ThemeProvider>
  );
}
